import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function VideoBankFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [resolution] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const categories = [
    { id: "all", name: "Todos" },
    { id: "nature", name: "Natureza" },
    { id: "city", name: "Cidade" },
    { id: "people", name: "Pessoas" },
    { id: "technology", name: "Tecnologia" },
    { id: "business", name: "Negócios" },
    { id: "abstract", name: "Abstrato" },
    { id: "aerial", name: "Aéreo" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/video_bank?page=${pageNum}&limit=16`;
      if (category !== "all") url += `&category=${category}`;
      if (resolution !== "all") url += `&resolution=${resolution}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching video bank:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [category]);

  const handleEditPost = (post) => {
    setSelectedVideo(null);
    setEditingPost(post);
  };

  const handlePostUpdated = (updatedPost) => {
    setPosts((prev) => prev.map((p) => (p._id === updatedPost._id ? updatedPost : p)));
    setEditingPost(null);
  };

  const handlePostDeleted = (postId) => {
    setPosts((prev) => prev.filter((p) => p._id !== postId));
    setSelectedVideo(null);
  };

  const formatDuration = (seconds) => {
    if (!seconds) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  if (loading && posts.length === 0) {
    return <div className="videobank_feed_loading"><div className="videobank_loader"></div><span>Carregando vídeos...</span></div>;
  }

  return (
    <div className="videobank_feed">
      {categories.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {categories.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${category === filter.id ? "active" : ""}`}
                onClick={() => setCategory(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="videobank_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"/>
          </svg>
          <h3>Nenhum vídeo encontrado</h3>
          <p>Seja o primeiro a contribuir!</p>
        </div>
      ) : (
        <div className="videobank_grid">
          {posts.map((post) => (
            <div key={post._id} className="videobank_card" onClick={() => setSelectedVideo(post)}>
              <div className="videobank_thumbnail">
                <img src={post.videoBankData?.thumbnail || post.images?.[0]?.url || post.images?.[0] || "/images/default-video.png"} alt="" />
                <div className="videobank_overlay">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="40" height="40">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </div>
                <span className="videobank_duration">{formatDuration(post.videoBankData?.duration)}</span>
                {post.videoBankData?.resolution && (
                  <span className="videobank_resolution">{post.videoBankData.resolution}</span>
                )}
              </div>
              <div className="videobank_card_content">
                <h3>{post.videoBankData?.title || post.text}</h3>
                <div className="videobank_meta">
                  <Link to={`/profile/${post.user.username}`} className="videobank_author" onClick={(e) => e.stopPropagation()}>
                    <img src={post.user.picture} alt="" />
                    <span>{post.user.first_name}</span>
                  </Link>
                  <span className="videobank_downloads">{post.videoBankData?.downloads || 0} downloads</span>
                  <div onClick={(e) => e.stopPropagation()}>
                    <FeedPostMenu
                      post={post}
                      onEdit={handleEditPost}
                      onPostDeleted={handlePostDeleted}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="videobank_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais vídeos"}
          </button>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}

      {selectedVideo && (
        <div className="videobank_modal_overlay" onClick={() => setSelectedVideo(null)}>
          <div className="videobank_modal" onClick={(e) => e.stopPropagation()}>
            <button className="videobank_modal_close" onClick={() => setSelectedVideo(null)}>✕</button>
            <div className="videobank_modal_video">
              <video
                src={selectedVideo.videoBankData?.videoUrl || selectedVideo.images?.[0]}
                controls
                autoPlay
                poster={selectedVideo.videoBankData?.thumbnail}
              />
            </div>
            <div className="videobank_modal_info">
              <h2>{selectedVideo.videoBankData?.title}</h2>
              <p>{selectedVideo.videoBankData?.description || selectedVideo.text}</p>
              <div className="videobank_modal_details">
                <div><strong>Resolução:</strong> {selectedVideo.videoBankData?.resolution || "N/A"}</div>
                <div><strong>Duração:</strong> {formatDuration(selectedVideo.videoBankData?.duration)}</div>
                <div><strong>FPS:</strong> {selectedVideo.videoBankData?.fps || "N/A"}</div>
              </div>
              {selectedVideo.videoBankData?.tags?.length > 0 && (
                <div className="videobank_tags">
                  {selectedVideo.videoBankData.tags.map((tag, i) => (
                    <span key={i}>{tag}</span>
                  ))}
                </div>
              )}
              <div className="videobank_modal_footer">
                <Link to={`/profile/${selectedVideo.user.username}`} className="videobank_modal_author">
                  <img src={selectedVideo.user.picture} alt="" />
                  <span>{selectedVideo.user.first_name} {selectedVideo.user.last_name}</span>
                </Link>
                <a
                  href={selectedVideo.videoBankData?.downloadUrl || selectedVideo.videoBankData?.videoUrl}
                  download
                  className="videobank_download_btn"
                >
                  Download
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
